import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';

export const useStyles = makeStyles<Theme>(
    theme => ({
        header: {
            position: 'sticky',
            top: 0,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: 'var(--header-height-mobile)',
            width: '100%',
            zIndex: 10002,
            backgroundColor: theme.customization.background.C10,
            padding: '0 20px',
            borderBottom: `1px solid ${theme.customization.background.C30}`,
            transition: '0.3s ease-in-out',
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },
        appToolsHeader: {
            marginLeft: '-6.45%',
            width: '113%',
        },
        hideHeader: {
            top: 'calc(-1 * var(--header-height-mobile))',
            transition: '0.3s ease-in-out',
        },
        eventLogo: {
            display: 'inline-block',
            maxWidth: 150,
            maxHeight: 36,
        },
        logo: {
            maxWidth: 150,
            maxHeight: 32,
            minHeight: 36,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        burgerIcon: {
            height: 12,
            width: 15,
            display: 'inline-block',
            position: 'relative',
            '& span': {
                display: 'block',
                backgroundColor: theme.customization.background.G10,
                width: '100%',
                height: 2,
                marginTop: -1,
                position: 'absolute',
                left: 0,
                top: '50%',
            },
            '&:before,&:after': {
                content: '""',
                display: 'block',
                backgroundColor: theme.customization.background.G10,
                width: '100%',
                height: 2,
                position: 'absolute',
                left: 0,
                transformOrigin: 'center center',
                transform: 'rotate(0deg)',
                transition: 'all 0.3s ease',
            },
            '&:before': {
                top: 0,
                marginTop: -1,
            },
            '&:after': {
                bottom: 0,
                marginBottom: -1,
            },
            '&.openMenu': {
                '&:before': {
                    top: '50%',
                    transform: 'rotate(45deg)',
                },
                '&:after': {
                    bottom: '50%',
                    transform: 'rotate(-45deg)',
                },
                '& span': {
                    backgroundColor: 'transparent',
                },
            },
        },
    }),
    { classNamePrefix: 'drawer-navigation-xs' }
);
